export const CORP_JSAPI_TICKET = 'corp_jsapi_ticket';

export const APP_JSAPI_TICKET = 'app_jsapi_ticket';

export const EXTERNAL_USERID = 'external_userid';
/**
 * jsapi_ticket的key
 */
export const JSAPI_TICKET_INFO = 'jsapi_ticket_info';
/**
 * 重定向地址的kye
 */
export const REDIRECT_URI = 'redirect_uri';
